export class FeatureValue {
    id: number;
    value: string | boolean;
    subValue: string;
    description: string;

    constructor(featureValue: any) {
        this.id = featureValue.feature_id;
        this.value = featureValue.value;
        this.subValue = featureValue.sub_value;
        this.description = featureValue.description;
    }
}
